// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"a6d3d9a66953ffcf","617":"a6d3d9a66953ffcf","945":"a6d3d9a66953ffcf"}[chunkId] + ".css";
};